<template>
<div>
	<TopAppBar
	  :leftBtnMode="leftBtnMode"
	  :rightBtnMode="rightBtnMode"
	  :title="title"
	  :leftBtnMethod="leftBtnMethod"
	  :rightBtnMethod="rightBtnMethod"
    :hideCategory="false"
	  staticMode="true"
	>
	</TopAppBar>
<div class="d-flex h-full flex-column">
<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1 bg-white">
		<div class="d-flex align-items-center bg-white main-wrapper-header-inner">
			<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
				{{$t('3212')}}
			</div>
		</div>
		<div class="divider"></div>
		<div class="container container--narrow topContainer-data">
			<div class="pdt-50">
				<div class="t-headline10 t-line-h-30 l-spacing72 font-b">{{$t('3225')}}</div>
				<div class="t-body1 font-r l-spacing48 t-line-h-24 mgt-8 t-color-bodyGrayA">{{$t('3226')}}</div>
			</div>
			<div class="pdt-50">
				<div class="t-subtitle5 t-line-h-33  font-m">{{$t('3227')}}</div>
				<div class="t-body1 font-r t-line-h-24 mgt-4 t-color-bodyGrayA">{{$t('3228')}}</div>
			</div>
			<div class="pdt-24">
				 <div class=" box-subtabs">
					<div class="mdc-tab-bar top-tab-bar  main-tabs" role="tablist" id="examViewTab">
						<div class="mdc-tab-scroller">
							<div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll">
								<div class="mdc-tab-scroller__scroll-content">
									<button class="mdc-tab" :class="currentTab=='tab1'?'mdc-tab--active':''"  role="tab" tabindex="0" @click="tabChange('tab1')" @keypress="tabChange('tab1')" style="width: 50%;">
										<span class="mdc-tab__content">
											<span class="mdc-tab__text-label">
												{{$t('3229')}}
											</span>
										</span>
										<span class="mdc-tab-indicator" :class="currentTab=='tab1'?'mdc-tab-indicator--active':''">
											<span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
										</span>
										<span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
									</button>
									<button class="mdc-tab"  :class="currentTab=='tab2'?'mdc-tab--active':''" role="tab" tabindex="0" @click="tabChange('tab2')" @keypress="tabChange('tab2')" style="width: 50%;">
										<span class="mdc-tab__content">
											<span class="mdc-tab__text-label">
												{{$t('3230')}}
											</span>
										</span>
										<span class="mdc-tab-indicator" :class="currentTab=='tab2'?'mdc-tab-indicator--active':''">
											<span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
										</span>
										<span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
									</button>
								</div>
							</div>
						</div>
					</div>
				 </div>

				<form @submit.prevent="productSearch()" novalidate class="pdb-24 bg-white">
					<div class="mgt-36" v-if="currentTab == 'tab1'">
							<div class="mdc-select mdc-select--outlined w-full mdc--select__custom" :class="selectedCategory1?'hasActiveVal':''" id="selectDuty">
								<i class="mdc-select__dropdown-icon select-icon-custom"></i>
								<select class="font-r pdt-14 mdc-select__native-control mdc-select__anchor h-46 mdc-select-control-custom t-body6" ref="selectOp" v-model="selectedCategory1" @change="getCategory2($event.target.value)">
									<option :value="null" disabled>
										{{$t('3231')}}
									</option>
									<option v-for="(cat1, index) in categoryList1" :key="index" :value="cat1.id">
										{{cat1.name}}
									</option>
								</select>
								<div class="mdc-notched-outline">
									<div class="mdc-notched-outline__leading"></div>
									<div class="mdc-notched-outline__notch">
										<!-- <label class="mdc-floating-label">{{$t('759')}}</label> -->
									</div>
									<div class="mdc-notched-outline__trailing"></div>
								</div>
							</div>
					</div>
					<div class="mgt-36" v-if="currentTab == 'tab1'">
							<div class="mdc-select mdc-select--outlined w-full mdc--select__custom" :class="selectedCategory2?'hasActiveVal':''" id="selectResponsibility">
								<i class="mdc-select__dropdown-icon select-icon-custom"></i>
								<select class="font-r pdt-14 mdc-select__native-control mdc-select__anchor h-46 mdc-select-control-custom t-body6" v-model="selectedCategory2">
									<option :value="null" disabled>
										{{$t('3232')}}
									</option>
									<option v-for="(cat2, index) in categoryList2" :key="index" :value="cat2.id">
										{{cat2.name}}
									</option>
								</select>
								<div class="mdc-notched-outline">
									<div class="mdc-notched-outline__leading"></div>
									<div class="mdc-notched-outline__notch">
										<!-- <label class="mdc-floating-label">{{$t('759')}}</label> -->
									</div>
									<div class="mdc-notched-outline__trailing"></div>
								</div>
							</div>
					</div>
					<div class="mgt-36">
						<label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
							data-mdc-auto-init="MDCTextField"
							id="productNameEl" :class="productName?'textFieldVal':''"

							>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="my-label-id">{{currentTab=='tab1'?$t('3233'):$t('3239')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input"
								type="text"
								v-model="productName"
								ref="productNameUser"
								id="productName"
								name="productName"
								maxlength="50"

								/>
								<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-none"
								role="button">report_problem</i>
						</label>
					</div>
					<!-- <div class="mgt-36">
						<div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
							id="productNameEl" :class="productName?'textFieldVal':''"
						>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
												<span class="mdc-floating-label t-color-textDisabled">{{currentTab=='tab1'?$t('3233'):$t('3239')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input type="text" class="mdc-text-field__input"
								v-model="productName"
								ref="productNameUser"
								id="productName"
								name="productName"
								maxlength="50"
								tabindex="1"
							>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-none"
								role="button">report_problem</i>
						</div>
					</div> -->
						<!-- <div class="mgt-16 t-body3 font-r t-color-iconInactive d-flex align-items-center pdb-24" v-if="currentTab == 'tab2'" @click="moveToBarCodeReader">
							<i class="material-icons mgr-8" @click.prevent="moveToBarCodeReader">photo_camera</i> {{$t('3240')}}
						</div> -->
						<div class="pdt-24 t-body4 t-line-h-22 l-spacing39 t-color-bodyGrayB font-r" v-if="currentTab == 'tab2'">{{$t('3238')}}</div>
							<div class="mgt-50 mgb-50">
								<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8">
									<div class="mdc-button__ripple"></div>
									<span class="mdc-button__label t-body2 font-r">{{$t('3234')}}</span>
								</button>
							</div>
				</form>
			</div>
			</div>
			<div class="divider" :class="listData !=''?'d-block':'d-none'"></div>
				<div class="bg-documentGray" v-if="isNoData==false" :style="listData !=''?'display:block':'display:none'">
						<div class="container container--narrow pdb-50">
							<div class="pdt-40">
									<div class="t-body3 t-color-bodyGrayA t-line-h-22 l-spacing42 font-r">{{$t('3237')}} </div>
									<ProductSearch :listData="listData"></ProductSearch>
							</div>
						</div>
				</div>
			<div class="bg-documentGray no-data-bg" v-if="isNoData==true">
				<div class="container container--narrow pdb-50">
					<div class="pdt-50 pdb-50">
						<div class="t-headline8 t-center t-line-h-28 font-r">{{$t('3241')}}</div>
						<div class="t-body1 t-center t-line-h-24 font-r t-color-bodyGrayA t-center">{{$t('3242')}}</div>
					</div>
				</div>
			</div>
	</main>
	</div>
</div>
</template>

<script>
/**
 * 단독 전체 시험 목록 메인 컴포넌트(independent total exam list main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define



//import { MDCTabBar} from "@material/tab-bar";
import {MDCSelect} from '@material/select';
import {MDCRipple} from '@material/ripple'
import {MDCTextField} from '@material/textfield'
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'
import storeApi from '@/api/storeMgtApi.js'
import ProductSearch from '@/components/storeManagement/ProductSearch.vue'
import NoData from '../common/NoData.vue'
//import InfiniteLoading from 'vue-infinite-loading'
import TopAppBar from '@/components/TopAppBar.vue';
import TopAppBarDrawer from '@/components/TopAppBarDrawer.vue';
import {topAppBarMixin} from '@/mixins/topAppBar.js'

export default {
	components: {
		NoData,
		ProductSearch,
		TopAppBar,
		TopAppBarDrawer
	},
mixins: [topAppBarMixin],
	data() {
		return {
			tabBar: null,
			categoryList1: null,
			categoryList2: null,
			selectedCategory1: null,
			selectedCategory2: null,
			productName: '',
			productNameTextField: null,
			barCode:'',
			barCodeTextField: null,
			submitState: false,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			text:'',
			currentTab: 'tab1',
			isNinja: true,
			isNoData: '',
			title: localStorage.getItem("brandName"),
		}
	},

	mounted() {
		this.$refs.selectOp.focus()
		this.setMaterialUi()
		storeApi.storeProductCategory().then((response) => {
		   this.categoryList1 = response.data.data
		})

		this.tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'))
		let curTab = localStorage.getItem('setTab')
		let proName = localStorage.getItem('productName')
		if(curTab){
		   this.currentTab = curTab
		}

		if(this.currentTab=='tab2') {
			this.$refs.productNameUser.focus()
			this.setMaterialUi()
			this.tabBar.activateTab(1)
			this.$nextTick(() => {
				this.productNameTextField = new MDCTextField(document.querySelector('#productNameEl'))
				localStorage.removeItem('setTab')
			})
		}

		if(proName){
			this.productName = proName
			this.barCode = this.productName
			this.productSearch()
		}

	},

	methods: {
		tabChange(currentTab){
			this.currentTab = currentTab;
			if(this.currentTab=="tab1") {
				this.selectedCategory1 =null
				this.selectedCategory2 =null
				this.productName = ''
				this.barCode=''
				//this.setMaterialUi()
				this.productSearch()
				this.$nextTick(() => {
						const selects = [].map.call(document.querySelectorAll('.mdc-select'), function(el) {
						let select = new MDCSelect.attachTo(el)
						return select
					})
					this.$refs.selectOp.focus()
					this.productNameTextField = new MDCTextField(document.querySelector('#productNameEl'))
				})
				 localStorage.removeItem('setTab')
				 localStorage.removeItem('productName')

			}
			if(this.currentTab=="tab2") {
				this.selectedCategory1 =null
				this.selectedCategory2 =null
				this.productName = ''
				this.barCode=''
				this.productSearch()
				this.tabBar.activateTab(1)
				this.$nextTick(() => {
					this.productNameTextField = new MDCTextField(document.querySelector('#productNameEl'))
					this.$refs.productNameUser.focus();
					let box = document.querySelector('#app');
					box.classList.add("bg-documentGray");
					let topHeader = document.querySelector('.top-header');
					// let topContainer = document.querySelector('.topContainer-data');
					// let mainHeaderInn =  document.querySelector('.main-wrapper-header-inner');
					// let noDatabg =  document.querySelector('.no-data-bg');
					// let gettingValues = (box.scrollHeight - (topHeader.offsetHeight + topContainer.offsetHeight + mainHeaderInn.offsetHeight));
					// noDatabg.style.minHeight = `${gettingValues}px`;
				})
				localStorage.removeItem('setTab')
			}
		},

		setMaterialUi() {
			const selects = [].map.call(document.querySelectorAll('.mdc-select'), function(el) {
				let select = new MDCSelect.attachTo(el)
				return select
			})

			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
			//this.$refs.productNameUser.focus()
			this.productNameTextField = new MDCTextField(document.querySelector('#productNameEl'))
		},


		getCategory2( value){
			let childrenList = this.categoryList1.filter(element=>element.id==value).map(element => {
				return element.children
			});
			this.categoryList2 = childrenList['0']
			this.selectedCategory2 =null
		},

		productSearch() {
			let params
			if(this.currentTab=="tab1") {
				params = {
					category : this.selectedCategory2,
					name: this.productName,
				}
			}

			if(this.currentTab=="tab2") {
				params = {
					barcode: this.productName
				}
			}
			//console.log('params',params)
			if(this.selectedCategory2 || this.productName || this.barCode) {
				storeApi.storeProductSearch(params).then((response) => {
					this.listData = response.data.data.content
					if (this.listData.length>0) {
						this.isNoData = false
					} else {
						this.isNoData = true
					}

				}).catch((err) => {
					$state.error()
				})
			} else {
				this.isNoData = true
			}
		},

		moveToBarCodeReader(){
			this.$router.push("/barcode").catch(()=>{});
		},

		// onDecode(a, b, c) {
		//     console.log(a, b, c);
		//     this.text = a;
		//     if(this.currentTab=='tab2'){
		//         this.productName = this.text
		//         this.productSearch()
		//     }
		//     if (this.id) clearTimeout(this.id);
		//     this.id = setTimeout(() => {
		//         if (this.text === a) {
		//         this.text = "";
		//         }
		//     }, 5000);
		// },

		// onLoaded() {
		//     console.log("load");
		// },

		goBackListPage() {
			localStorage.removeItem('productName')
			localStorage.removeItem('setTab')
			this.productName=''
			this.barCode=''
			this.$router.push({
				name: 'StoreManagement',
			})
		}

	}
}
</script>
<style scoped>

	.imagePlaceHolder{
		width: 104px;
		height: 104px;
	}
	.mdc-select-control-custom {
		border: 0;
		padding-top: 10px;
	}
	.give-padding{
		padding-left: 0;
	}
	.imageWrapper{
		/* max-height: 100px; */
		display: flex;
	}
		.img-thumbnail{
		width: 104px;
	}
	.img-thumbnail img{
		border-radius: 4px;
		width: 104px;
		height: 104px;
		object-fit: cover;
	}


	.img-border{
		margin-bottom: -4px !important;
	}
	.closeIcon {
		top: -8px;
		right: -8px;
		border-radius: 50%;
		width: 24px;
		height: 24px;
		background: var(--Iconinactive);
		display: flex;
		justify-content: center;
		align-items: center;
		border: 3px solid var(--DocumentWhite);
		color: var(--DocumentWhite);
		line-height: 0px;
	}
	html[dir="rtl"] .closeIcon {
		left: -8px;
	}
	.mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__leading, .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__notch, .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__trailing{
		border-color: var(--Textfeildactive);
	}
	.mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__leading, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__notch, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{
		border-color: var(--Textfeildactive) !important;
	}

</style>
